import { render, staticRenderFns } from "./CrCollapse.vue?vue&type=template&id=4786e109&scoped=true"
import script from "./CrCollapse.vue?vue&type=script&lang=ts"
export * from "./CrCollapse.vue?vue&type=script&lang=ts"
import style0 from "./CrCollapse.vue?vue&type=style&index=0&id=4786e109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786e109",
  null
  
)

export default component.exports